<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 31.6 31.9" style="enable-background:new 0 0 31.6 31.9;" xml:space="preserve">
    <g>
      <path class="st0" fill="#fff" d="M15.8,0.8C7.5,0.8,0.7,7.6,0.7,15.9s6.8,15.1,15.1,15.1S31,24.3,31,15.9S24.2,0.8,15.8,0.8z M11.2,23.1H7.5 v-11h3.7V23.1z M9.3,10.6L9.3,10.6c-1.3,0-2-0.8-2-1.9c0-1.1,0.8-1.9,2.1-1.9c1.3,0,2,0.8,2,1.9C11.4,9.7,10.6,10.6,9.3,10.6z M24.3,23.1h-3.6v-5.9c0-1.5-0.5-2.5-1.9-2.5c-1,0-1.6,0.7-1.9,1.3c-0.1,0.2-0.1,0.6-0.1,0.9v6.1h-3.6c0-10,0-11,0-11h3.6v1.6 c0.5-0.8,1.3-1.8,3.3-1.8c2.4,0,4.2,1.6,4.2,4.9V23.1z"/>
    </g>
  </svg>
</template>
